import styled from '@emotion/styled'

export const StyledMarkdownContainer = styled.div`
  & strong {
    font-weight: bold;
  }
  & em {
    font-style: italic;
  }
  & * {
    overflow-wrap: anywhere;
  }
`
